import React, { createContext, useState, useContext, useEffect } from 'react';
import authService from '../services/admin/authService';
import { adminLogout } from '../utils/admin/logout';

const AdminAuthContext = createContext(null);

export const useAdminAuth = () => {
  const context = useContext(AdminAuthContext);
  if (!context) {
    throw new Error('useAdminAuth must be used within an AdminAuthProvider');
  }
  return context;
};

export const AdminAuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);
  const [isAuthenticated, setIsAuthenticated] = useState(false);

  // Initialize auth state on mount
  useEffect(() => {
    const initializeAuth = () => {
      const currentUser = authService.getCurrentUser();
      const token = authService.getToken();
      
      if (currentUser && token) {
        setUser(currentUser);
        setIsAuthenticated(true);
      } else {
        setUser(null);
        setIsAuthenticated(false);
      }
      setLoading(false);
    };

    initializeAuth();

    // Listen for storage changes (for multi-tab sync)
    const handleStorageChange = (e) => {
      if (e.key === 'admin_token' || e.key === 'admin_user') {
        initializeAuth();
      }
    };

    window.addEventListener('storage', handleStorageChange);
    return () => window.removeEventListener('storage', handleStorageChange);
  }, []);

  // Login function
  const login = async (email, password) => {
    try {
      const response = await authService.login(email, password);
      const currentUser = authService.getCurrentUser();
      
      setUser(currentUser);
      setIsAuthenticated(true);
      
      return response;
    } catch (error) {
      throw error;
    }
  };

  // Logout function
  const logout = (options = {}) => {
    /*authService.logout();
    setUser(null);
    setIsAuthenticated(false);*/

    const result = adminLogout(options);
    if (result) {
      setUser(null);
      setIsAuthenticated(false);
    }
    return result;
  };

  // Check permission functions
  const hasPermission = (permission) => {
    return authService.hasPermission(permission);
  };

  const hasAnyPermission = (permissions) => {
    return authService.hasAnyPermission(permissions);
  };

  const hasAllPermissions = (permissions) => {
    return authService.hasAllPermissions(permissions);
  };

  const value = {
    user,
    loading,
    isAuthenticated,
    login,
    logout,
    hasPermission,
    hasAnyPermission,
    hasAllPermissions,
  };

  return (
    <AdminAuthContext.Provider value={value}>
      {children}
    </AdminAuthContext.Provider>
  );
};